var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { css } from 'styled-components';
import { BREAKPOINTS_SIZES } from './data';
/**
 * Returns a CSS attribute with a parametrized value. Parametrized values can be
 * either a single value or an different values under different breakpoints.
 * The `transform` function, if specified, is applied to the value before being
 * used.
 *
 * @param {string} attribute - The CSS attribute name.
 * @param {Prop} prop - The prop to be parametrized. Can be specified in both flat or parametric form.
 * @param {Transformer} [transform] - The transformer function to be applied to the prop. Used to convert the prop to a CSS value in case the specified values are not (e.g.: D.S. tokens).
 * @returns {FlattenSimpleInterpolation} The CSS outcome.
 */
export function parametricStyle(attribute, prop, transform) {
  var hasTransformer = typeof transform === 'function';
  if (typeof prop === 'string' || typeof prop === 'number') return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ": ", ";\n    "], ["\n      ", ": ", ";\n    "])), attribute, hasTransformer ? transform(prop) : prop);
  var styles = Object.keys(prop).map(function (breakpoint) {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      @media screen and (min-width: ", ") {\n        ", ": ", ";\n      }\n    "], ["\n      @media screen and (min-width: ", ") {\n        ", ": ", ";\n      }\n    "])), BREAKPOINTS_SIZES[breakpoint], attribute, hasTransformer ? transform(prop[breakpoint]) : prop[breakpoint]);
  });
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), styles);
}
function columnsToPercentage(width) {
  return "".concat(Number(width) / 12 * 100, "%");
}
export function parametricWidth(width, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = '100%';
  }
  return parametricStyle('width', width, function (v) {
    return columnsToPercentage(v) || defaultValue;
  });
}
var templateObject_1, templateObject_2, templateObject_3;